module.exports = __webpack_public_path__ + "static/media/art-sample-5.2ec30584.png";